
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.514 8.797L3.14 15.172a1.12 1.12 0 01-1.589 0l-1.06-1.06a1.12 1.12 0 010-1.589l4.52-4.518-4.52-4.52a1.12 1.12 0 010-1.588L1.546.828a1.12 1.12 0 011.59 0l6.374 6.375c.446.44.446 1.153.005 1.594z","fill":"#282E3E"}})])
          )
        }
      }
    